import { IntlMessageFormat } from "intl-messageformat";

//#region src/icu-handler.ts
const moduleCache = /* @__PURE__ */ new WeakMap();
const getParsedICUMessages = (m, locale) => {
	const moduleCachedResult = moduleCache.get(m);
	if (moduleCachedResult && moduleCachedResult[locale]) return moduleCachedResult[locale];
	const parsedICUMessages = {};
	for (const translation of Object.keys(m)) {
		const intlMessageFormat = new IntlMessageFormat(m[translation], locale);
		parsedICUMessages[translation] = { format: (params) => intlMessageFormat.format(params) };
	}
	moduleCache.set(m, {
		...moduleCachedResult,
		[locale]: parsedICUMessages
	});
	return parsedICUMessages;
};

//#endregion
export { getParsedICUMessages };
//# sourceMappingURL=icu-handler-ckZzFRyo.mjs.map